module.exports = __webpack_public_path__ + "img/IMG_0328_L_Black.021bdc5e.jpg";